export default __webpack_public_path__ + "static/media/cryptodash.47cdd907.png";